import { IUserPrivacy } from '../models/user-privacy-model';
import UserPrivacyMapper from '../mappings/user-privacy-mapper';
import { Config } from '../models/config-viewmodel';
import { UserPrivacy } from '../models/user-privacy-viewmodel';


class UserPrivacyService {
    private userPrivacyMapper = new UserPrivacyMapper();

    constructor() { }

    public getUserPrivacy = (config: Config, HttpService: any) => {
        return this.getUserData(this.getUserPrivacyQuery(), config, HttpService);
    }

    private getUserData = (url: string, config: Config, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(config.apiBasePath ? config.apiBasePath + url : url).then((result: IUserPrivacy) => {
                resolve(this.userPrivacyMapper.mapUserPrivacy(result));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }
    public updateUserPrivacy = (data: UserPrivacy, HttpService: any) => {
        return this.postUserData(this.updateUserPrivacyQuery(), this.userPrivacyMapper.mapUserPrivacy(data), HttpService);
    }

    private postUserData = (url: string, data: any, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.post(url, data).then((result: any) => {
                resolve(result);
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getUserPrivacyQuery = (): string => {
        return `/api/employees/privacy`;
    }

    private updateUserPrivacyQuery = (): string => {
        return `/api/employees/privacy`;
    }
}

export default new UserPrivacyService();